import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
// our components
import PermissionDetails from 'components/Permission/Details';

const ScreenPermissionDetails = props => {
  const { classes, match, t } = props;
  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} md={6}>
          <GridItem>
            <h3>{t('permissions.detail.title')}</h3>
            <PermissionDetails id={match.params.id} />
          </GridItem>
        </GridItem>
      </GridContainer>
    </div>
  );
};

ScreenPermissionDetails.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(
  withStyles(validationFormsStyle)(ScreenPermissionDetails),
);
